<app-spinner *ngIf="!loaded"></app-spinner>
<div class="se-app" *ngIf="loaded">
  <div class="se-app__main">
    <div class="se-app__content" *ngIf="membershipBlocks.length && persona">
      <app-header [organization]="organization"></app-header>
      <div [ngClass]="{'se-app__section--border-bottom': affiliateOrganization, 'se-app__section': !affiliateOrganization}">
        <div class="se-block">
          <h2 class="se-app__content-title--mb0">Here's your {{ membershipBlocks.length > 1 ? 'Memberships' : 'Membership' }}!</h2>
        </div>
        <div class="se-block">
          <p class="se-text se-block">Thanks for being a member of {{ organization.name }}!</p>
        </div>
        <div class="se-block" *ngFor="let membershipBlock of membershipBlocks; last as isLast">
          <div class="se-block">
            <se-membership-card
              [se-data-card]="membershipBlock.card">
            </se-membership-card>
          </div>
          <div class="se-block" style="display: flex; justify-content: space-around; flex-wrap: wrap;">
            <a [appCardDownload]="membershipBlock.iosDownloadParams"><img alt="Add to Apple Wallet" style="width: 120px; height: 38px; flex: auto;" src="https://s3.amazonaws.com/sportngin-snap-production/ui_themes/assets/latest/images/add_to_apple_wallet.png"/></a>
            <a [appCardDownload]="membershipBlock.androidDownloadParams"><img alt="Add to Google Pay" style="width: 200px; height: 38px; flex: auto;" src="https://s3.amazonaws.com/sportngin-snap-production/ui_themes/assets/latest/images/add_to_google_pay.png"/></a>
          </div>
          <div class="se-block" *ngIf="!isLast">
            <hr class="pl-divider">
          </div>
        </div>
        <div class="se-block">
          <p class="se-text se-block">You can <a class="pl-link" [href]="mySeUrl">view and print</a> your memberships anytime on SportsEngine.</p>
          <div class="se-block">
            <se-button
              se-data-emphasis="high"
              se-data-is-full-width="true"
              [se-data-value]="buttonValue"
              (click)="redirect()">
            </se-button>
          </div>
        </div>
      </div>
      <div *ngIf="affiliateOrganization" class="se-app__section">
        <div class="se-block">
          <p>Do you need another membership for {{ affiliateOrganization.name }}?</p>
        </div>
        <div class="se-block">
          <se-button
            se-data-emphasis="medium"
            se-data-is-full-width="true"
            [se-data-value]="'Get Another Membership'"
            (click)="redirectToQuizzard()">
          </se-button>
        </div>
      </div>
      <app-footer [organization]="organization"></app-footer>
    </div>
  </div>
  <app-subfooter></app-subfooter>
</div>
